<template>
  <div class="solution">
    <solution-group v-if="pathUrl === '/solution/group'"/>
    <solution-city v-if="pathUrl === '/solution/city'"/>
    <solution-project v-if="pathUrl === '/solution/project'"/>
    <service/>
    <customer-recognition></customer-recognition>
    <digital-marketing></digital-marketing>
    <marketing-upgrade></marketing-upgrade>
  </div>
</template>

<script>
import SolutionGroup from './GroupView.vue'
import SolutionCity from './CityView.vue'
import SolutionProject from './ProjectView.vue'
import Service from './components/Service.vue'
import customerRecognition from '@/components/CustomerRecognition.vue'
import digitalMarketing from '@/components/DigitalMarketing.vue'
import marketingUpgrade from '@/components/MarketingUpgrade.vue'
import swTracker from '@/mixins/tracker.js'
import utils from '@/utils'

export default {
  name: "SolutionView",
  mixins: [swTracker],
  components:{
    SolutionGroup,
    SolutionCity,
    SolutionProject,
    customerRecognition,
    digitalMarketing,
    marketingUpgrade,
    Service
  },
  data () {
    return {
      pathUrl: '/solution',
      pathName: ''
    }
  },
  watch: {
    '$route.path' () {
      this.pathUrl = utils.changeRoutePath(this.$route.path)
      this.pathName = this.$route.name
    },
  },
  mounted () {
    this.pathUrl = utils.changeRoutePath(this.$route.path)
    this.pathName = this.$route.name
  },
  methods: {

  },
}
</script>
<style lang="scss" scoped>
.group-page {
  width: 100%;
  height: 100%;
  .section {
    width: 100%;
    height: 100%;
   
    &-box {
      width: 100%;
      height: 100%;
      padding: 80px 0;
      &.bg-w{
        background: #FAFAFC;
      }
      &.bg-b{
        background: linear-gradient(180deg, #F6F9FF 0%, #FBFCFF 100%);;
      }
      .section-con {
        width: 1200px;
        margin: 0 auto;
        text-align: center;
      }
      .title {
        font-size: 32px;
        font-weight: 500;
        color: #2d2e30;
        padding-bottom: 20px;
      }
      .subtitle {
        font-size: 16px;
        font-weight: 400;
       
        padding-bottom: 60px;
        color: #5a5c60;
      }
    }
  }
}

// 移动端布局
@import "@/views/solution/min-solution";
</style>
